/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../App.css';
import '../../bootstrap-5.2.3-dist/css/bootstrap.min.css';
import { Box, Container, TextField, Button, Card, CardContent, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import UploadComponent from '../../pages/UploadComponent';

const PublicFigurePostForm = () => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
    const [publicFigures, setPublicFigures] = useState([]);
    const [selectedPublicFigure, setSelectedPublicFigure] = useState('');
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [fileUrl, setFileUrl] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {
        fetchPublicFigures();
    }, []);

    const fetchPublicFigures = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/.netlify/functions/listPublicFigures`);
            setPublicFigures(response.data);
        } catch (error) {
            console.error('Error fetching public figures', error);
        }
    };

    const handleCreatePost = async () => {
        if (!selectedPublicFigure || !title) {
            alert('Please select a public figure and provide a title first');
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/.netlify/functions/createPublicFigurePost`, {
                publicFigureId: selectedPublicFigure,
                title,
                content,
                fileUrl,
            });

            setSelectedPublicFigure('');
            setTitle('');
            setContent('');
            setFileUrl(null);
        } catch (error) {
            console.error('Error creating post', error);
        }
    };

    return (
        <Container maxWidth="xs">
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                }}>
                <Card sx={{
                    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
                    backgroundColor: '#f2f2f2',
                    borderRadius: '15px',
                    border: '2px solid #FFFFFF00'
                }}>
                    <CardContent>
                        <h2 style={{
                            color:'#333333'
                        }}>Create Post for Public Figure</h2>
                        <form>
                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <InputLabel id="publicFigure-label" sx={{color: '#9ca3af'}}>Public Figure</InputLabel>
                                <Select
                                    labelId="publicFigure-label"
                                    id="publicFigure"
                                    value={selectedPublicFigure}
                                    onChange={(e) => setSelectedPublicFigure(e.target.value)}
                                    label="Public Figure"
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>Select a public figure</em>
                                    </MenuItem>
                                    {publicFigures.map((publicFigure) => (
                                        <MenuItem key={publicFigure.id} value={publicFigure.id}>
                                            {publicFigure.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="title"
                                    label="Title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>

                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="content"
                                    label="Content"
                                    value={content}
                                    onChange={(e) => setContent(e.target.value)}
                                    multiline
                                    rows={4}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>

                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <UploadComponent setFileUrl={setFileUrl} setIsUploading={setIsUploading}/>
                            </FormControl>

                            <Button
                                // fullWidth
                                width="50%"
                                type="button"
                                color="primary"
                                variant="contained"
                                onClick={handleCreatePost}
                                sx={{
                                    mt: 2,
                                    backgroundColor: '#15a2fa',
                                    '&:hover': {
                                        backgroundColor: '#FF005C',
                                    },
                                }}
                                disabled={isUploading}
                            >
                                Create Post
                            </Button>
                        </form>

                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
};

export default PublicFigurePostForm;
